// modules/scroll-settler.js
export const ScrollSettle = (() => {
    let delay = 220;
    let t = null;
    const listeners = new Set();
    const emit = () => listeners.forEach(fn => fn());
    const kick = () => { clearTimeout(t); t = setTimeout(emit, delay); };

    window.addEventListener('scroll', kick, { passive: true });
    if (window.ScrollTrigger) ScrollTrigger.addEventListener('scrollEnd', emit);

    return {
        on: fn => { listeners.add(fn); return () => listeners.delete(fn); },
        setDelay: ms => { delay = Math.max(0, ms|0); },
        ping: kick,
    };
})();
